import { ApiResponse, TokenData, LeadIntent } from '../models';
import * as http from './http';
import ApiService from './service';

export class LeadIntentService extends ApiService {
  public async loadAllIntent() {
    const url = `${this.apiDomain}/api/lead-intent`;

    const resposne = await http.get<ApiResponse<LeadIntent[]>>(url, this.store);
    return resposne?.data?.data;
  }
  public async updateIntent(data: LeadIntent, id?: string) {
    const url = `${this.apiDomain}/api/lead-intent/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
}
